import Vue from 'vue'
import VueRouter from 'vue-router'
import isProd from '../settings'

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV == 'production' ? '/' : '',
  routes: [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/Home.vue'),
    children: [
      {
        meta: {
          title : 'Login',
        },
        path: '/login',
        name: 'LoginPage',
        component: () => import('../views/Login.vue')
      },
      {
        meta: {
          title : 'Register',
        },
        path: '/register',
        name: 'RegisterPage',
        component: () => import('../views/Register.vue')
      },
      {
        meta: {
          title : 'ForgotPassword',
        },
        path: '/forgot-password',
        name: 'ForgotPasswordPage',
        component: () => import('../views/ForgotPassword.vue')
      },
      {
        meta: {
          title : 'ResetPassword',
        },
        path: '/reset-password',
        name: 'ResetPasswordPage',
        component: () => import('../views/ResetPassword.vue')
      },
      {
        meta: {
          title : 'Home Page',
        },
      path: '/',
      name: 'HomeContent',
      component: () => import('../views/HomeContent.vue')
    },{
      meta: {
        title : 'Upload',
      },
      path: '/upload',
      name: 'UploadPage',
      component: () => import('../views/Upload.vue')
    },{
      meta: {
        title : 'API Documentation',
      },
      path: '/api-documentation',
      name: 'ApiDocumentation',
      component: () => import('../views/ApiDocumentation.vue')
    },{
      meta: {
        title : 'Pricing',
      },
      path: '/pricing',
      name: 'Pricing',
      component: () => import('../views/Pricing.vue')
    },{
      meta: {
        title : 'Personal Use',
      },
      path: '/personal-use',
      name: 'PersonalUse',
      component: () => import('../views/PersonalUse.vue')
    },{
      meta: {
        title : 'E-Commerce',
      },
      path: '/e-commerce',
      name: 'Ecommerce',
      component: () => import('../views/Ecommerce.vue')
    },{
      meta: {
        title : 'Photography',
      },
      path: '/photography',
      name: 'Photography',
      component: () => import('../views/Photography.vue')
    },{
      meta: {
        title : 'Marketing',
      },
      path: '/marketing',
      name: 'Marketing',
      component: () => import('../views/Marketing.vue')
    },{
      meta: {
        title : 'News',
      },
      path: '/news',
      name: 'News',
      component: () => import('../views/News.vue')
    },{
      meta: {
        title : 'Car Dealers',
      },
      path: '/car-dealers',
      name: 'CarDealers',
      component: () => import('../views/CarDealers.vue')
    },{
      meta: {
        title : 'Developer Use',
      },
      path: '/developer-use',
      name: 'DeveloperUse',
      component: () => import('../views/DeveloperUse.vue')
    },{
      meta: {
        title : 'Refunds',
      },
      path: '/refunds',
      name: 'Refunds',
      component: () => import('../views/Refunds.vue')
    }
    ,{
      meta: {
        title : 'Terms Of Service',
      },
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: () => import('../views/TermsOfService.vue')
    }
    ,{
      meta: {
        title : 'Privacy Policy',
      },
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('../views/PrivacyPolicy.vue')
    }
    ,{
      meta: {
        title : 'General Terms and Conditions',
      },
      path: '/general-terms-conditions',
      name: 'GeneralTermsConditions',
      component: () => import('../views/GeneralTermsConditions.vue')
    }
    ,{
      meta: {
        title : 'Data Processing Agreement',
      },
      path: '/dpa',
      name: 'DataProcessingAgreement',
      component: () => import('../views/DataProcessingAgreement.vue')
    }
    ,{
      meta: {
        title : 'Contact',
      },
      path: '/contact-form',
      name: 'Contact',
      component: () => import('../views/Contact.vue')
    },
    {
      meta: {
        title : 'Be Anyone',
      },
      path: '/beanyone',
      name: 'Beanyone',
      component: () => import('../views/BeAnyone.vue')
    },
    {
      meta: {
        title : 'AI Interior Design',
      },
      path: '/interior',
      name: 'Interior',
      component: () => import('../views/Interior.vue')
    }
  ]
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: () => import('../views/Dashboard.vue'),
    children: [
    {
      meta: {
        title : 'Credit Details',
      },
      path: '/credit-details',
      name: 'CreditDetails',
      component: () => import('../views/CreditDetails.vue')
    },{
      meta: {
        title : 'Client Details',
      },
      path: '/client-details',
      name: 'ClientDetails',
      component: () => import('../views/ClientDetails.vue')
    },{
      meta: {
        title : 'Referral Details',
      },
      path: '/referral-details',
      name: 'ReferralDetails',
      component: () => import('../views/ReferralDetails.vue')
    },{
      meta: {
        title : 'Files',
      },
      path: '/files',
      name: 'Files',
      component: () => import('../views/Files.vue')
    },{
      meta: {
        title : 'Billings',
      },
      path: '/user-billings',
      name: 'Billings',
      component: () => import('../views/Billings.vue')
    }
  ]
  },
  {
    path: '/products',
    name: 'ProductPage',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/checkout',
    name: 'CheckoutPage',
    component: () => import('../views/Checkout.vue')
  },
  {
    path: '/successSubscription',
    name: 'SuccessSubscriptionPage',
    component: () => import('../views/SuccessSubscription.vue')
  },
  {
    path: '/cancelSubscription',
    name: 'CancelSubscriptionPage',
    component: () => import('../views/CancelSubscription.vue')
  },
],
});

router.afterEach((to) => {
  if(isProd)
  {
    window.gtag('js', new Date());
    window.gtag('config', 'G-G9TRVD5Q03', {
      'page_title' : to.meta.title,
      'page_path': to.path
    });
  }
  
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/login', '/register', '/forgot-password', '/reset-password', '/upload', '/pricing', '/api-documentation', 
  '/car-dealers', '/e-commerce', '/news', '/personal-use', '/photography', '/marketing', '/developer-use', '/contact-form', '/refunds',
  '/terms-of-service', '/privacy-policy', '/general-terms-conditions', '/dpa', '/beanyone'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  Vue.nextTick(() => {
    document.title = 'Remove Background from Images & Download - simpleish.io';
  });

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});
